var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"min-height":"200px"}}),_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#d96c6c","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }